import {
  Avatar,
  Box,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  Skeleton,
  Typography,
} from '@mui/material'

const getProgressColor = (value) => {
  if (value >= 75) return 'success'
  if (value >= 33) return 'warning'
  return 'error'
}

const getEstadoChip = (p_evaluacion) => {
  if (p_evaluacion >= 100) return { label: 'Completada', color: 'success' }
  if (p_evaluacion > 0) return { label: 'En progreso', color: 'primary' }
  return { label: 'Sin iniciar', color: 'default' }
}

const EvaluadoresCard = ({ evaluador, onEvaluadorClick, loading }) => {
  if (loading) {
    return (
      <Card sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
          <Skeleton variant="circular" width={64} height={64} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={16} />
          </Box>
        </Box>
        <Divider />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Box sx={{ flex: 1 }}>
              <Skeleton variant="text" width="30%" height={16} sx={{ mb: 0.5 }} />
              <Skeleton variant="text" width="70%" height={20} />
            </Box>
            <Skeleton variant="circular" width={64} height={64} />
          </Box>
        </CardContent>
      </Card>
    )
  }

  const porcentaje = evaluador.p_evaluacion || 0
  const progressColor = getProgressColor(porcentaje)
  const estadoChip = getEstadoChip(porcentaje)
  const [apellidos = '', nombre = ''] = (evaluador?.nombre ?? '').split(', ')

  const handleClick = () => {
    if (typeof onEvaluadorClick === 'function') {
      onEvaluadorClick(evaluador)
    }
  }

  return (
    <Card
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        cursor: 'pointer',
        transition: 'box-shadow 0.2s, transform 0.2s',
        '&:hover': { boxShadow: 4, transform: 'translateY(-2px)' },
      }}
      onClick={handleClick}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
        <Avatar
          src={`/assets/images/${evaluador?.imagen}`}
          sx={{ width: 64, height: 64, transition: '0.3s' }}
        />
        <Box sx={{ flex: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold" lineHeight={1.2}>
            {apellidos}
          </Typography>
          <Typography
            variant="caption"
            sx={{ textTransform: 'uppercase', letterSpacing: 1, color: 'text.secondary' }}
          >
            {nombre}
          </Typography>
        </Box>
        <Chip label={estadoChip.label} color={estadoChip.color} size="small" />
      </Box>

      <Divider />

      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box sx={{ flex: 1, mr: 2 }}>
            <Typography variant="overline" color="text.secondary" lineHeight={1.5}>
              Puesto
            </Typography>
            <Typography variant="body2">{evaluador?.puestos?.[0]?.descripcion ?? '—'}</Typography>
          </Box>

          <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
              variant="determinate"
              value={porcentaje}
              color={progressColor}
              size={64}
              thickness={5}
            />
            <Box
              sx={{
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="caption" fontWeight="bold" color={`${progressColor}.main`}>
                {`${Math.round(porcentaje)}%`}
              </Typography>
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  )
}

export default EvaluadoresCard
